<template>
  <v-layout
    row
    wrap
  >
    <!-- <v-flex xs12>
      <v-card
        flat
        color="transparent"
      >
        <v-card-title>
          <span class="display-2">
            <img
              v-if="country.base64Flag"
              style="width: 50px; max-height: 40px; vertical-align: middle;"
              :src="country.base64Flag"
            />
            {{ country.name }} <span class="grey--text font-weight-thin display-1">({{ country.nameEn }})</span>
          </span>
        </v-card-title>
      </v-card>
    </v-flex> -->
    <v-flex
      xs12
      lg8
    >
      <v-expansion-panel :value="0">
        <v-expansion-panel-content>
          <div
            slot="header"
            class="title"
          >
            <span class="display-1">
              <img
                v-if="country.base64Flag"
                style="width: 40px; max-height: 30px; vertical-align: middle;"
                :src="country.base64Flag"
              />
              {{ country.name }} <span class="grey--text font-weight-thin headline">({{ country.nameEn }})</span>
            </span>
          </div>
          <v-card>
            <v-card-text>
              <vue-markdown :source="country.description || 'אין מידע'"></vue-markdown>
            </v-card-text>

            <v-btn
              flat
              color="primary"
              @click.prevent="editCountry(countryId)"
              v-if="shouldShow(['ADMIN', 'RESEARCHER'], $store.getters['user/user'])"
            >
              <v-icon small>edit</v-icon> עריכה
            </v-btn>
          </v-card>

        </v-expansion-panel-content>
        <!-- <v-expansion-panel-content
          v-for="(region, i) in regions"
          :key="i"
          v-if="region"
        >
          <div
            slot="header"
            class="title"
          >{{ region.name }} <span
              class="grey--text font-weight-thin subheading"
              v-if="region.nameEn"
            >({{ region.nameEn }})</span>
          </div>
          <v-card>
            <v-card-text>
              <vue-markdown :source="region.description || 'אין מידע'"></vue-markdown>
            </v-card-text>
            <v-btn
              flat
              color="primary"
              @click.prevent="editRegion(region._id)"
              v-if="shouldShow(['ADMIN', 'RESEARCHER'], $store.getters['user/user'])"
            >
              <v-icon small>edit</v-icon> עריכה
            </v-btn>
          </v-card>
        </v-expansion-panel-content> -->
      </v-expansion-panel>
      <country-details
        class="hidden-md-and-down"
        :country-id="countryId"
      />
    </v-flex>
    <v-flex
      xs12
      lg4
    >
      <country-partners :country-id="countryId" />
      <country-events
        :country-id="countryId"
        class="mt-3"
      />
    </v-flex>
  </v-layout>
</template>

<script>
import CountryPartners from "./CountryPartners";
import CountryEvents from "./CountryEvents";
import CountryDetails from "./CountryDetails";
import VueMarkdown from "vue-markdown";
import { format } from "date-fns";
import { throttle } from "lodash";
import Mixins from "@/mixins/mixins";
import { mapState, mapGetters } from "vuex";
import shouldShow from "@/utils/shouldShow";

export default {
  data() {
    return {
      loading: false
    };
  },
  computed: {
    ...mapState({}),
    countryId() {
      return this.$route.params.id;
    },
    country() {
      return this.$store.state.entities.countries[this.countryId];
    },
    regions() {
      return this.$store.getters["countries/countryRegions"](this.countryId);
    },
    partners() {
      return this.$store.getters["countries/countryPartners"](this.countryId);
    },
    partnerTypes() {
      return this.$store.state.entities.partnerTypes;
    },
    entityEditDialog: {
      get() {
        return this.$store.state.entityEditDialog;
      },
      set(payload) {
        this.$store.commit("TOGGLE_ENTITY_EDIT_DIALOG", payload);
      }
    }
  },
  beforeMount() {},
  mounted() {},
  methods: {
    format,
    shouldShow,
    editCountry(countryId) {
      let entity = this.$store.state.entities.countries[countryId];
      this.$store.commit("ADD_EDITABLE_ENTITY", {
        entity,
        schema: "countrySchema"
      });
      this.$store.commit("SET_ENTITY_EDIT_DATA", {
        id: entity._id,
        resource: this.$store.state.resources.fullCountry,
        isNew: false
      });
      this.entityEditDialog = true;
    },
    editRegion(regionId) {
      let entity = this.$store.state.entities.regions[regionId];
      this.$store.commit("ADD_EDITABLE_ENTITY", {
        entity,
        schema: "regionSchema"
      });
      this.$store.commit("SET_ENTITY_EDIT_DATA", {
        id: entity._id,
        resource: this.$store.state.resources.fullRegion,
        isNew: false
      });
      this.entityEditDialog = true;
    }
  },
  components: {
    VueMarkdown,
    CountryPartners,
    CountryEvents,
    CountryDetails
  },
  watch: {
    countryId: function(val) {
      // this.fetchRegions();
    }
  },
  mixins: [Mixins]
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/countries/country/GeneralDetails.vue